export const EMPTY_FILTER_VALUES = [];
